// =============================================================================
// LOGO CLOUD SECTION COMPONENT
// =============================================================================

import React from 'react';
import { ExternalLink } from 'lucide-react';
import type { ContentComponent } from '@/types';

interface LogoCloudSectionProps {
  component: ContentComponent;
}

/**
 * Logo Cloud Section Component
 */
export const LogoCloudSection: React.FC<LogoCloudSectionProps> = ({ component }) => {
  return <LogoCloudSectionImpl component={component} />;
};

/**
 * Logo Cloud Section Implementation
 */
const LogoCloudSectionImpl: React.FC<{ component: ContentComponent }> = ({ component }) => {
  const { id, title, content, metadata } = component;
  
  const logos = metadata?.logos || [];
  const columns = metadata?.columns || 6;
  
  return (
    <section id={id} className="content-section logo-cloud-section">
      <div className="container">
        {title && (
          <div className="section-header">
            <h2>{title}</h2>
            {content && <p>{content}</p>}
          </div>
        )}
        
        <div className={`logo-cloud grid-cols-${columns}`}>
          {logos.map((logo: any, index: number) => (
            <div key={index} className="logo-item">
              {logo.url ? (
                <a
                  href={logo.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="logo-link"
                  aria-label={`${logo.name} website`}
                >
                  <div className="logo-image">
                    <img src={logo.logo} alt={logo.alt || `${logo.name} logo`} loading="lazy" />
                  </div>
                  <div className="logo-overlay">
                    <ExternalLink size={16} />
                  </div>
                </a>
              ) : (
                <div className="logo-image">
                  <img src={logo.logo} alt={logo.alt || `${logo.name} logo`} loading="lazy" />
                </div>
              )}
            </div>
          ))}
        </div>
        
        {logos.length === 0 && (
          <div className="logo-cloud-placeholder">
            <p>Add your client or partner logos to showcase your trusted relationships.</p>
          </div>
        )}
      </div>
    </section>
  );
};

export { LogoCloudSectionImpl };

